import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import BiometricValidation from '../pages/BiometricValidation';
import UserList from '../pages/UserList';
import UserDetails from '../pages/UserDetails';
import Login from '../pages/Login';
import PrivateRoute from '../components/PrivateRoute';
import Layout from '../components/Layout';
import ApiKeys from '../pages/ApiKeys';
import CreateApiKey from '../pages/CreateApiKey';
import CreateUser from '../pages/CreateUser';
import UserAdminList from '../pages/UserAdminList';
import CreateUserAdmin from '../pages/CreateUserAdmin';
import EditUserAdmin from '../pages/EditUserAdmin';
import LivenessValidation from '../pages/LivenessValidation';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Rota pública */}
      <Route path="/login" element={<Login />} />

      {/* Rotas protegidas */}
      <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/biometric" element={<BiometricValidation />} />
        <Route path="/users" element={<UserList />} />
        <Route path="/users/create" element={<CreateUser />} />
        <Route path="/users/:id" element={<UserDetails />} />
        <Route path="/api-keys" element={<ApiKeys />} />
        <Route path="/api-keys/create" element={<CreateApiKey />} />
        <Route path="/user-admins" element={<UserAdminList />} />
        <Route path="/user-admins/create" element={<CreateUserAdmin />} />
        <Route path="/user-admins/:id/edit" element={<EditUserAdmin />} />
        <Route path="/liveness" element={<LivenessValidation />} />
      </Route>

      {/* Redireciona qualquer outra rota para a home */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoutes; 